module.exports = __webpack_public_path__ + "static/media/slideMobile2.1e6a95c1.jpg";